module.exports = __webpack_public_path__ + "static/14-2f26a51659524692197b047c497cf083.jpg";